import React from 'react';
import { ReactComponent as CoSafeLogo } from '../../assets/brand/logo-with-text.svg';
import { SplashWrapper, SplashContainer } from './Splash.styles';

type SplashProps = {
  className?: string | undefined;
};
const Splash = (props: SplashProps) => {
  const { className } = props;
  return (
    <SplashWrapper className={className}>
      <SplashContainer>
        <CoSafeLogo />
      </SplashContainer>
    </SplashWrapper>
  );
};

export default Splash;
